module.exports = __webpack_public_path__ + "img/ky.1409fc84.png";